import ActionTypes from "../constants/ActionTypes";
import BASE_URL from "../constants/Api";
import axiosInstance from "../helpers/refreshTokenMiddleware";

/* =========================================================
 * 管理者新規作成 (Admin Create)
 * ========================================================= */
export const fetchAdminCreateRequest = () => ({
    type: ActionTypes.FETCH_ADMIN_CREATE_REQUEST,
});

export const fetchAdminCreateSuccess = (response) => ({
    type: ActionTypes.FETCH_ADMIN_CREATE_SUCCESS,
    payload: response,
});

export const fetchAdminCreateFailure = (error) => ({
    type: ActionTypes.FETCH_ADMIN_CREATE_FAILURE,
    payload: error,
    error: true,
});

export const createAdmin = (formData) => async (dispatch) => {
  dispatch(fetchAdminCreateRequest());

    try {
        const accessToken = localStorage.getItem("accessToken");

        if (!accessToken) {
            window.location.href = "/login";
            return;
        }

        const body = {
            login_id: formData.login_id,
            password: formData.password,
            admin_name: formData.admin_name,
            otp_enable: formData.otp_enable ? 1 : 0,
            mail_address: formData.mail_address || "",
        };

        const response = await axiosInstance.post(`${BASE_URL}?path=admin&type=insert-info-data`, body, {
                headers: {
                Authorization: `Bearer ${accessToken}`,
                },
            }
        );

        const data = response.data;
        //APIが文字列のみを返す場合
        if (typeof data === "string") {
            dispatch(fetchAdminCreateFailure(data));
            return { error: data };
        }

        if (!data || data.status !== 200) {
            const errorMsg =
                data?.message ||
                data?.respons?.message ||
                data?.respons ||
                "作成に失敗しました。";

            dispatch(fetchAdminCreateFailure(errorMsg));
            return { error: errorMsg };
        }

        // 成功処理
        dispatch(fetchAdminCreateSuccess(data.respons));
        return { payload: data.respons };

    } catch (err) {
        //Axiosでの例外エラー
        const errorMsg =
            err.response?.data ||
            err.response?.data?.respons ||
            err.response?.data?.message ||
            err.message;

        dispatch(fetchAdminCreateFailure(errorMsg));
        return { error: errorMsg };
    }
};